import isEmpty from "lodash/isEmpty";
import { useActivityTemplateType } from "PFApp/activities/hooks";
import { Activity, Profile } from "PFTypes";

type AssigneeResult = {
  assignee?: Profile;
  canView: boolean;
  canWrite: boolean;
};

export const useAssignee = (activity?: Partial<Activity>): AssigneeResult => {
  const { isEngagement, isRole } = useActivityTemplateType(activity);
  const canWrite = (isEngagement || isRole) && !!activity?.coowned;
  const assignee = activity?.assignee?.profile;

  return { assignee, canView: !isEmpty(assignee), canWrite };
};
